/**
 * Cart Confirmation Redirect - Prevents add to cart on pick-your-plan and pick-your-frequency.
 * Intercepts clicks, stores selection in sessionStorage, redirects to cart confirmation.
 */
(function() {
  const PICK_PLAN_PATH = '/pages/pick-your-plan';
  const PICK_FREQ_PATH = '/pages/pick-your-frequency';
  const CART_CONFIRM_KEY = 'cartConfirmationData';

  function isPickPlanOrFrequencyPage() {
    const path = window.location.pathname.replace(/\/$/, '');
    return path === PICK_PLAN_PATH || path === PICK_FREQ_PATH;
  }

  function isAddToCartClick(target) {
    if (!target || !target.closest) return false;
    var el = target;
    var path = window.location.pathname.replace(/\/$/, '');
    // On pick-frequency page: only intercept tray selection clicks, NOT frequency selection clicks.
    // Frequency "Select" is in [data-frequently]; tray "Select" is in [trays]. Let frequency clicks
    // reach Vue so _selectFrequency runs and shows the tray section.
    if (path === PICK_FREQ_PATH) {
      if (el.closest('[data-frequently]') && !el.closest('[trays]')) return false;
    }
    if (el.closest('.no-thanks-btn-wrapper')) return true;
    if (el.closest('button') && el.closest('button').classList.contains('ATCButtonLast')) return true;
    if (el.classList && el.classList.contains('ATCButtonLast')) return true;
    if (el.hasAttribute && (el.hasAttribute('freevariantid') || el.hasAttribute('freeVariantId'))) return true;
    var card = el.closest('.card-plans');
    if (card && card.querySelector('.ATCButtonLast')) return true;
    if (el.closest('[trays]') && el.closest('[trays]').querySelector('.ATCButtonLast')) return true;
    if (el.closest('[data-details-product]') && (el.closest('button') || el.tagName === 'BUTTON')) return true;
    return false;
  }

  function getVariantFromClick(target) {
    var btn = target.closest('button') || target;
    var card = target.closest('.card-plans') || target.closest('[trays]');
    var trayCard = target.closest('[trays]');
    var variantId = null;
    var isTray = false;
    if (btn && (btn.hasAttribute('silicon_tray_btn') || btn.hasAttribute('silicone_tray_btn'))) {
      var varEl = (trayCard || card) ? (trayCard || card).querySelector('[data-var_id]') : null;
      variantId = (varEl && varEl.getAttribute('data-var_id')) || btn.getAttribute('data-var_id');
      isTray = true;
    } else if ((btn || card) && (btn.getAttribute('freevariantid') || (card && card.querySelector('[freevariantid]')))) {
      variantId = (btn && btn.getAttribute('freevariantid')) || (card && card.querySelector('[freevariantid]') && card.querySelector('[freevariantid]').getAttribute('freevariantid'));
      isTray = true;
    }
    var selectedFreq = document.querySelector('#selected_frequency');
    var grassVariantId = (selectedFreq && selectedFreq.getAttribute('variant-id')) || localStorage.getItem('defaulrVariantID') || localStorage.getItem('defaultVariantID');
    return { variantId: variantId, grassVariantId: grassVariantId, isTray: isTray };
  }

  function collectAndStoreCartData(variantInfo, event) {
    const target = event.target;
    const btn = target.closest('button') || target;
    const selectedFreq = document.querySelector('#selected_frequency');
    // PYP stores defaulrSellingPlanId (typo) and defaulrVariantID - support both for backward compat
    const sellingPlanId = localStorage.getItem('defaultSellingPlanId') || localStorage.getItem('defaulrSellingPlanId') || (selectedFreq && selectedFreq.getAttribute('value'));
    const grassVariantId = variantInfo.grassVariantId || (selectedFreq && selectedFreq.getAttribute('variant-id')) || localStorage.getItem('defaulrVariantID') || localStorage.getItem('defaultVariantID');
    let trayVariantId = variantInfo.isTray ? variantInfo.variantId : null;
    let freeVariantId = null;
    if (!variantInfo.isTray && btn) {
      trayVariantId = btn.getAttribute('addontray') || (btn.closest('[addontray]') && btn.closest('[addontray]').getAttribute('addontray'));
      freeVariantId = btn.getAttribute('freevariantid') || (btn.querySelector('[freevariantid]') && btn.querySelector('[freevariantid]').getAttribute('freevariantid'));
    }
    if (!grassVariantId && !trayVariantId && !freeVariantId) return false;

    const deliveryFreq = document.querySelector('.deliveryFrequency');
    const freqOption = deliveryFreq && deliveryFreq.options[deliveryFreq.selectedIndex];
    const sellingPlanIdFromSelect = freqOption ? freqOption.value : sellingPlanId;
    // Prefer localStorage (updated when user clicks frequency card), then selected_frequency, then PYP default
    const frequencyText = localStorage.getItem('defaultFrequencyText') || (selectedFreq && (selectedFreq.getAttribute('frequencytext') || selectedFreq.getAttribute('frequencyText'))) || '';

    let productTitle = 'DoggieLawn', productSize = '24" x 48"', productDesc = 'Dogs 30lbs+', trayTitle = 'No Tray';
    let productImage = '', trayImage = '', selectedStage = '';
    try {
      const app = window.app || (window.theme && window.theme.App);
      var hashHandle = (window.location.hash || '').split('#handle=')[1] || '';
      if (app && app.pickYourPlan) {
        const pyp = app.pickYourPlan;
        selectedStage = pyp.selectedStage || hashHandle || '';
        productTitle = (pyp.selectedProduct ? (pyp.selectedProduct.charAt(0).toUpperCase() + pyp.selectedProduct.slice(1)) + ' DoggieLawn' : '') || 'DoggieLawn';
      } else {
        selectedStage = selectedStage || hashHandle;
      }
      const planTitle = document.querySelector('.plan-title');
      if (planTitle) productTitle = planTitle.textContent || productTitle;
      console.log(planTitle, 'planTitleplanTitleplanTitle ');
      
      const selectedTrayEl = document.querySelector('.selected_tray');
      if (selectedTrayEl) trayTitle = selectedTrayEl.textContent || trayTitle;
      const trayCard = btn && btn.closest('[trays]');
      if (trayCard) {
        const h2 = trayCard.querySelector('.card-title h2, h2');
        if (h2) trayTitle = h2.textContent || trayTitle;
        const img = trayCard.querySelector('img');
        if (img) trayImage = img.src || '';
      }
      const productImg = document.querySelector('.card-img img, [data-image-design-slider] img');
      if (productImg) productImage = productImg.src || '';
      const storedCardImage = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('cardImagePYP');
      if (storedCardImage) productImage = storedCardImage;
      const storedCardTitle = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('cardTitlePYP');
      if (storedCardTitle) productTitle = storedCardTitle;
    } catch (e) {}

    const sizeMap = { standard: '24" x 16"', medium: '24" x 20"', large: '24" x 24"', xl: '24" x 48"', xxl: '48" x 48"' };
    const descMap = { standard: 'Dogs under 15lbs', medium: 'Dogs 10-25lbs', large: 'Dogs 20-35lbs', xl: 'Dogs 30lbs+', xxl: 'Dogs 60lbs+' };
    const stage = selectedStage || (productTitle && productTitle.toLowerCase().replace(' doggielawn', '').replace(' ', ''));
    productSize = sizeMap[stage] || '24" x 48"';
    productDesc = descMap[stage] || 'Dogs 30lbs+';

    // Resolve data-product stage: XL/XXL may use group-1/2/3 or doublexl
    function getProductDataEl(stage) {
      if (!stage) return null;
      var el = document.querySelector('[data-product-' + stage + ']');
      if (el) return el;
      if (stage === 'xl') {
        return document.querySelector('[data-product-group-1]') || document.querySelector('[data-product-group-2]') || document.querySelector('[data-product-group-3]');
      }
      if (stage === 'xxl') {
        return document.querySelector('[data-product-doublexl]') || document.querySelector('[data-product-xxl]') || document.querySelector('[data-product-group-1]');
      }
      return null;
    }
    var deliveryFreqSrc = deliveryFreq;
    if (!deliveryFreqSrc || !deliveryFreqSrc.options || deliveryFreqSrc.options.length === 0) {
      var selectHtml = localStorage.getItem('selectHtml');
      if (selectHtml) {
        var tmp = document.createElement('div');
        tmp.innerHTML = selectHtml;
        deliveryFreqSrc = tmp.querySelector('.deliveryFrequency') || tmp.querySelector('select');
      }
    }
    var frequencyOptionsHtml = '';
    var frequencyOptions = [];
    var trayOptions = [];
    try {
      if (deliveryFreqSrc) {
        frequencyOptionsHtml = (deliveryFreq && deliveryFreq.outerHTML) || deliveryFreqSrc.outerHTML || '';
        for (var i = 0; i < deliveryFreqSrc.options.length; i++) {
          var opt = deliveryFreqSrc.options[i];
          var vid = opt.getAttribute('variant-id') || opt.getAttribute('data-variant-id');
          var price = opt.getAttribute('data-price');
          if ((!vid || !price) && selectedStage) {
            var dpEl = getProductDataEl(selectedStage);
            if (dpEl) {
              try {
                var pData = JSON.parse(dpEl.textContent);
                if (pData.variants) {
                  for (var v = 0; v < pData.variants.length; v++) {
                    var vv = pData.variants[v];
                    if (vv.selling_plan_allocations) {
                      for (var s = 0; s < vv.selling_plan_allocations.length; s++) {
                        var sp = vv.selling_plan_allocations[s].selling_plan || vv.selling_plan_allocations[s];
                        var spId = sp && (sp.id || sp.selling_plan_id);
                        if (spId && String(spId) === String(opt.value)) {
                          vid = vv.id;
                          price = vv.price;
                          break;
                        }
                      }
                    }
                    if (vid) break;
                  }
                }
              } catch (e2) {}
            }
          }
          frequencyOptions.push({ sellingPlanId: opt.value, variantId: vid, price: price, text: opt.textContent.trim() });
        }
      }
      document.querySelectorAll('[trays] .card-plans, [data-tray-standard] .card-plans, [data-tray-medium] .card-plans, [data-tray-large] .card-plans, [data-tray-group-1] .card-plans, [data-tray-doublexl] .card-plans').forEach(function(card) {
        var b = card.querySelector('button[data-var_id], button[silicon_tray_btn], button[silicone_tray_btn]');
        if (!b) b = card.querySelector('button[freeVariantId], button[freevariantid]');
        if (!b) b = card.querySelector('[data-var_id], [freeVariantId], [freevariantid]');
        var titleEl = card.querySelector('.card-title h2, h2');
        var priceEl = card.querySelector('.discounted-price, .price-contentt p, .price');
        var price = 0;
        if (priceEl) {
          if (priceEl.textContent.toLowerCase().indexOf('free') >= 0) price = 0;
          else {
            var pt = priceEl.textContent.replace(/[^0-9.]/g, '');
            if (pt) price = Math.round(parseFloat(pt) * 100);
          }
        }
        var vid = b ? (b.getAttribute('data-var_id') || b.getAttribute('freeVariantId') || b.getAttribute('freevariantid')) : null;
        if (vid && titleEl) trayOptions.push({ variantId: vid, title: titleEl.textContent.trim(), price: price });
      });
    } catch (e) {}
    var trayPrice = 0;
    if (trayVariantId && trayOptions.length) {
      for (var tp = 0; tp < trayOptions.length; tp++) {
        if (trayOptions[tp].variantId == trayVariantId) { trayPrice = trayOptions[tp].price; break; }
      }
    } else if (freeVariantId && trayOptions.length) {
      for (var tp = 0; tp < trayOptions.length; tp++) {
        if (trayOptions[tp].variantId == freeVariantId) { trayPrice = trayOptions[tp].price; break; }
      }
    }

    var productPrice = 0;
    if (frequencyOptions.length) {
      for (var fp = 0; fp < frequencyOptions.length; fp++) {
        if (frequencyOptions[fp].sellingPlanId === (sellingPlanIdFromSelect || sellingPlanId) || frequencyOptions[fp].variantId == grassVariantId) {
          productPrice = Number(frequencyOptions[fp].price) || 0;
          break;
        }
      }
    }
    const data = {
      grassVariantId: grassVariantId || undefined,
      sellingPlanId: sellingPlanIdFromSelect || sellingPlanId || undefined,
      trayVariantId: trayVariantId || undefined,
      freeVariantId: freeVariantId || undefined,
      quantity: 1,
      frequencyText: frequencyText,
      frequencyOptionsHtml: frequencyOptionsHtml || undefined,
      frequencyOptions: frequencyOptions.length ? frequencyOptions : undefined,
      trayOptions: trayOptions.length ? trayOptions : undefined,
      productPrice: productPrice || undefined,
      trayPrice: trayPrice || undefined,
      productTitle: productTitle,
      productSize: productSize,
      productDesc: productDesc,
      trayTitle: trayTitle,
      productImage: productImage,
      trayImage: trayImage,
      selectedStage: selectedStage,
      timestamp: Date.now()
    };

    try {
      const existing = sessionStorage.getItem(CART_CONFIRM_KEY);
      const existingData = existing ? JSON.parse(existing) : {};
      const merged = Object.assign({}, existingData, data);
      if (grassVariantId) merged.grassVariantId = grassVariantId;
      if (trayVariantId) merged.trayVariantId = trayVariantId;
      if (freeVariantId) merged.freeVariantId = freeVariantId;
      if (sellingPlanIdFromSelect || sellingPlanId) merged.sellingPlanId = sellingPlanIdFromSelect || sellingPlanId;
      sessionStorage.setItem(CART_CONFIRM_KEY, JSON.stringify(merged));
      return true;
    } catch (e) { return false; }
  }

  function handleClick(e) {
    if (!isPickPlanOrFrequencyPage()) return;
    if (!isAddToCartClick(e.target)) return;

      e.preventDefault();
      e.stopPropagation();
    e.stopImmediatePropagation();

    const variantInfo = getVariantFromClick(e.target);
    if (collectAndStoreCartData(variantInfo, e)) {
      var trayNode = e.target.closest && e.target.closest('[freevariantid], [freeVariantId]');
      var freeVid = trayNode
        ? (trayNode.getAttribute('freevariantid') || trayNode.getAttribute('freeVariantId'))
        : (e.target.getAttribute('freevariantid') || e.target.getAttribute('freeVariantId'));
      if (freeVid) {
        try { sessionStorage.setItem('additionalTray', freeVid); } catch (err) {}
      }
      window.location.href = '?view=cart-confirmation';
      return;
    }
  }

  function init() {
    if (!isPickPlanOrFrequencyPage()) return;
    document.addEventListener('click', handleClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  if ((window.location.search || '').indexOf('view=cart-confirmation') === -1) return;

  window.toggleCart = function toggleCart() {
    var app = window.app;
    if (app && typeof app._toggleCartDrawer === 'function') {
      app._toggleCartDrawer();
    }
  };

  document.addEventListener(
    'click',
    function (e) {
      var cartAnchor = e.target && e.target.closest && e.target.closest('.cart-link a');
      if (!cartAnchor) return;
      e.preventDefault();
      e.stopPropagation();
      window.toggleCart();
    },
    true
  );
})();